/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from "react-i18next";
import queryString from 'query-string';

import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { useEnumApi } from 'contexts/EnumApiContext';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import FileDownloadIcon from "components/FileDownloadIcon";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals';
import AddressSearchSwitcher from 'components/layer/AddressSearchSwitcher';
import { getCompanyById, getCompanyInfoExistsByQuery, patchCompany } from 'components/axios/companyAxios';
import { extensionCheck, ROLE } from 'data/data';
import { LoadingButton } from '@mui/lab';
import CompanyModifyZone from './company-modify-zone';
import CompanyModifyUser from './company-modify-user';
import { useDispatch } from 'react-redux';
import { notifyLogoUpdated } from 'store/reducers/companySlice';
import CompanyModifyZoneNantong from './company-modify-zone-nantong';

const CompanyUserModifySetting = () => {
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const timezone      = (process.env.REACT_APP_TIMEZONE || 'Asia/Seoul').toLowerCase();
    const { getEnumValueByEnumName, loginInfo } = useEnumApi();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
                // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const { control, register, handleSubmit, reset, setValue, formState : {isDirty, errors } } = useForm({});
    const [addressInfo, setAddressInfo] = useState({});
   
    const qs = queryString.parse(window.location.search);
    const searchParam = '?searchField='+(qs?.searchField||'')+'&searchKeyword='+(qs?.searchKeyword||'')+'&searchType='+(qs?.searchType||'')+'&searchStatus='+(qs?.searchStatus||'')
    +'&page='+(qs?.page||'')+'&size='+(qs?.size||'');

    const {id} = useParams();
    
    const [isLoading, setIsLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [fileLoading, setFileLoading] = useState(false);
    const [company, setCompany] = useState({});
    // const [users, setUsers] = useState([]);
    const [zones, setZones] = useState([]);

    const [businessRegFile, setBusinessRegFile] = useState(null);
    const [businessRegFileId, setBusinessRegFileId] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [logoFileId, setLogoFileId] = useState(null);
    
    const requestRefresh = useCallback(() => {
      setRefreshKey((prev) => prev + 1);
    }, []);

    useEffect(()=>{
        if (isNaN(id)) {
            window.location.replace('/company'+searchParam);
            return;
        }
// console.log(id)
        getCompanyById(id).then((res)=> {
            // console.log(res)
            setCompany(res);
            setValue('address', res.info?.address || '');
            // setUsers(res.users);
            setZones(res.equipmentZones);

            let addressinfo = {
                address_name: res.info?.address
            }
            // if (appLanguage === 'zh-cn') {
            if (timezone === ('Asia/Shanghai').toLowerCase()) {
                addressinfo.chinaRegionCode = res.info?.chinaRegion?.selected.code ?? null;
            } else {
                addressinfo.lat = res.info?.latitude ?? null;
                addressinfo.lng = res.info?.longitude ?? null;
            }
            setAddressInfo(addressinfo)

            setBusinessRegFileId(res.info?.businessRegFile?.id || null)
            setLogoFileId(res.info?.logoFile?.id || null)

            // let arr = Array.from({length : res.users.length},() => false);
            // setUserModifyView(arr);

            // let arr2 = Array.from({length : res.equipmentZones.length},() => false);
            // setZoneModifyView(arr2);
            setIsLoading(true);
        })
    },[id, isLoading, refreshKey]);

    // 관리주체('MAN')일 때만 주소를 필수값으로 설정
    const isAddressRequired = company.type === 'MAN';

    const [domainCheckStr, setDomainCheckStr] = useState('');
    const dupleCheckDomain = (domain) => {
        if (domain) {
            getCompanyInfoExistsByQuery({domain, excludeId : company.info?.id}).then((data)=>{
                if (data) {
                    setDomainCheckStr(t('message.common.alert.domain.use'));
                // } else {
                //     setDomainCheckStr(t('message.common.alert.id.available'));
                } else {
                    setDomainCheckStr('')
                }
            }).catch((err)=>{
                console.log(err);
                handleAlertClick(err.response?.data?.message || err.message);
            })
        } else {
            setDomainCheckStr('')
        }
    }

    const onSubmit = async(data) => {
        setFileLoading(true);
        console.log(data)

        try {
            let isCheck = true;
            if (data.domain) {
				const res = await getCompanyInfoExistsByQuery({domain : data.domain, excludeId : company.info?.id});
				if (res) {
					isCheck = false;
				}
			}

            if (!isCheck) {
                handleAlertClick(t('message.common.alert.domain.use'));
                setFileLoading(false);
                return;
            }

            let formData = new FormData();
            let dto = {
                id : company.id,
                info : {
                    id : company.info?.id,
                    businessRegNo: data.businessRegNo,
                    name: data.businessName,
                    address: data.address,
                    contact: data.businessContact,
                    // latitude : addressInfo?.lat,
                    // longitude : addressInfo?.lng
                },
                loginActiveStatus : data.businessStatus
            };

            // if (appLanguage === 'zh-cn') {
            if (timezone === ('Asia/Shanghai').toLowerCase()) {
                dto.info.chinaRegionCode = addressInfo?.chinaRegionCode ?? null;
            } else {
                dto.info.latitude = addressInfo?.lat ?? null;
                dto.info.longitude = addressInfo?.lng ?? null;
            }
            
            if (loginInfo.role === ROLE.SA.code) {
                dto.info.domain = data.domain
            } else if (loginInfo.role === ROLE.AD.code) {
                dto.info.domain = company.info.domain;
            }
// console.log(logoFile)
            if (logoFile) {
                if (!extensionCheck(logoFile.name, "I")) {
                    handleAlertClick(t('message.common.alert.file.not.match.type'));
                    setFileLoading(false);
                    return;
                }
                formData.append("logoFile", logoFile);
            } else {
// console.log(company.info?.logoFile)
// console.log(logoFileId)
                if (company.info?.logoFile && logoFileId !== null) {
                    dto.info.logoFile = {id : company.info?.logoFile.id};
                } else if (company.info?.logoFile && logoFileId === null) {
                    dto.info.logoFile = {id : null};
                }
            }

            if (businessRegFile) {
                console.log(businessRegFile)
                formData.append("businessRegFile", businessRegFile);
            } else {
                if (company.info?.businessRegFile && businessRegFileId !== null) {
                    dto.info.businessRegFile = {id : company.info.businessRegFile.id};
                } else if (company.info?.businessRegFile && businessRegFileId === null) {
                    dto.info.businessRegFile = {id : null};
                }
            }

            console.log(dto);
            formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

            openModal(modals.confirmModal, {
                onSubmit : async(value) => {
                    console.log('company modify')
                    try {
					    await patchCompany(company.id, formData);
                        handleAlertClick(t('message.common.alert.modify.done'));
                        if (loginInfo.role !== ROLE.SA.code && loginInfo.role !== ROLE.CS.code) {
                            if ((logoFile || (company.info?.logoFile && logoFileId === null)) && loginInfo.role === ROLE.AD.code && loginInfo.company?.id === company.id) {
                                console.log(22222)
                                dispatch(notifyLogoUpdated())
                            }
                        }
                        setLogoFile(null)
                        setFileLoading(false);
                        setIsLoading(false)
                    } catch (err) {
					  console.log(err);
					  const msg = err.response?.data?.message || err.message;
                      if (msg) handleAlertClick(msg);
					} finally {
					  setFileLoading(false);
					  setIsLoading(false);
					}
                },
                onClose : () => {
                    setFileLoading(false);
                },
                message: t('message.common.alert.modify.question'),
            });
        } catch (err) {
			console.log(err);
			handleAlertClick(err.response?.data?.message || err.message);
			setFileLoading(false);
		}
    }

    // const handleDeleteBtnClick = () => {
    //     console.log(company)
    //     openModal(modals.confirmModal, {
    //         onSubmit : (value) => {
    //             console.log('company delete')
    //         },
    //         onClose : () => {
    //         },
    //         message: t('message.common.alert.delete.question'),
    //     });
    // }

    return (
      <div className="sub_container">
        <div>
          <h5 className="mro_m_left" style={{color:"#fff"}}>* {company.info?.name}</h5>
        </div>

        {/* 기본정보 */}
        <div className="mro_search">
            <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.subtitle.basic.info')}</h6>
        </div>
        {(isLoading && company && id) &&
        <>
        <form onSubmit={handleSubmit(onSubmit)}>
        <TableContainer>
        <Table aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
            <TableBody>
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.type')} *</TableCell>
                <TableCell style={{textAlign: "left"}}>
                    <Controller
                        name="companyType"
                        control={control}
                        render={({ field:{ name }}) => (
                            <CustomFormEnumSelect
                                style={{ minWidth: '90%', margin:"8px" , pointerEvents: 'none'}}
                                label={t('message.common.subtitle.company.type')}
                                register={register}
                                name={name}
                                requiredMessage={t('message.common.error.text.company.type.select')}
                                defaultValue={company?.type || ''}
                                key={'companyType'}
                                list={getEnumValueByEnumName('CompanyType')}
                            />
                        )}
                        rules={{ required: true }}
                    />
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.company.name')} *</TableCell>
                <TableCell colSpan={3} style={{textAlign: "left"}}>
                    <TextField id="businessName" 
                        aria-invalid={!isDirty ? undefined : errors.businessName ? "true" : "false"}
                        defaultValue={company?.info?.name || ''}
                        key={'businessName'}
                        {...register("businessName", {
                            required : t('message.common.error.text.company.name.input')
                        })} 
                        sx={{ m: 1, minWidth: '90%' }} 
                    />
                    {errors.businessName && <small role="alert"><br></br>{errors.businessName.message}</small>}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.address')} {isAddressRequired && <>*</>}</TableCell>
                <TableCell colSpan={5} style={{textAlign: "left"}}>
                    <Controller
                        control={control}
                        name="address"
                        rules={{ 
                            validate: (value, formValues) => {
                                // console.log(value)
                                console.log(formValues['companyType'])
                                if (company?.type === 'MAN' &&
                                    (value === null || value === undefined || value === '')) {
                                    return t('message.common.error.text.address.input');
                                }
                                return true;
                            }
                            // required: t('message.common.error.text.address.input') 
                        }}
                        render={({ field, fieldState }) => (
                        <AddressSearchSwitcher register={register} setValue={setValue} field={field} fieldState={fieldState} 
                            errors={errors} setAddressInfo={setAddressInfo} objName={'address'} addressInfo={{address_name:company?.info?.address ?? '', lat:company?.info?.latitude ?? null, lng:company?.info?.longitude ?? null, chinaRegionCode:company?.info?.chinaRegionCode ?? null}} />
                        )}
                    />
                    {!isAddressRequired &&
                    <Button variant="outlined" color="error" style={{marginTop:"10px"}} 
                        onClick={()=>{
                            setValue("address", "");
                            setAddressInfo({address_name: "", lat:"", lng:"", chinaRegionCode: ""})
                        }}
                    >X</Button>
                    }
                    {errors.address && <small role="alert"><br></br>{errors.address.message}</small>}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.contact')}</TableCell>
                <TableCell colSpan={3} style={{textAlign: "left"}}>
                    <TextField id="businessContact" 
                    // aria-invalid={!isDirty ? undefined : errors.businessContact ? "true" : "false"}
                    {...register("businessContact", {
                        // required : t('message.common.error.text.company.contact.input'),
                    })} 
                    defaultValue={company?.info?.contact || ''}
                    sx={{ m: 1, minWidth: '90%' }} />
                    {/* {errors.businessContact && <small role="alert"><br></br>{errors.businessContact.message}</small>} */}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.status')}</TableCell>
                <TableCell style={{textAlign: "left"}}>
                    {(loginInfo.role === ROLE.SA.code || (loginInfo.role === ROLE.AD.code && loginInfo.company?.id === company.id)) ?
                    <>
                    <Controller
                        control={control}
                        name="businessStatus"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            style={{ minWidth: '90%', margin:"8px" }}
                            label={t('message.common.subtitle.status')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.status.select')}
                            defaultValue={company?.loginActiveStatus || ''}
                            list={getEnumValueByEnumName('ActiveStatus')}
                        />
                        )}
                        rules={{ required: true }}
                    />
                    {errors.businessStatus && <small role="alert"><br></br>{errors.businessStatus.message}</small>}
                    </>
                    : 
                    <Controller
                        control={control}
                        name="businessStatus"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            style={{ minWidth: '90%', margin:"8px" , pointerEvents: 'none'}}
                            label={t('message.common.subtitle.status')}
                            register={register}
                            name={name}
                            requiredMessage={t('message.common.error.text.status.select')}
                            defaultValue={company?.loginActiveStatus || ''}
                            list={getEnumValueByEnumName('ActiveStatus')}
                        />
                        )}
                        rules={{ required: true }}
                    />
                    }
                </TableCell>
            </TableRow>
            {loginInfo.role === ROLE.SA.code && 
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.domain')}</TableCell>
                <TableCell colSpan={3} style={{textAlign: "left"}}>
                    <TextField id="domain" 
                        sx={{ m: 1, minWidth: '70%' }} 
                        {...register("domain", {})} 
                        defaultValue={company?.info?.domain || ''}
                        onChange={(e)=>{dupleCheckDomain(e.target.value)}}
                    />
                    {domainCheckStr && <small role="alert"><br/>{domainCheckStr}</small>}
                    <br/>* {t('message.common.text.only.domain.exclude.http')}
                </TableCell>
            </TableRow>
            }
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.business.register.no')}</TableCell>
                <TableCell colSpan={5} style={{textAlign: "left"}}>
                    <TextField id="businessRegNo" 
                        {...register("businessRegNo", {
                        })} 
                        defaultValue={company?.info?.businessRegNo || ''}
                        // InputProps={{ readOnly: true }}
                        sx={{ m: 1, minWidth: '90%' }}
                    />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.business.register.file')}</TableCell>
                <TableCell colSpan={5} style={{textAlign: "left"}}>
                    <div style={{display:"flex"}}>
                    <input
                        style={{margin:"8px"}}
                        type="file" 
                        onChange={(e)=>setBusinessRegFile(e.target.files[0])}
                    />
                    {(company.info?.businessRegFile && businessRegFileId !== null) &&
                        <div style={{display:"flex", alignItems: "center"}}>
                            <FileDownloadIcon file={company.info.businessRegFile} iconSize="large" viewFileName={true} />
                            <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer", paddingLeft:"5px"}} onClick={() => setBusinessRegFileId(null)}>-</RemoveCircleOutlineIcon>
                        </div>
                    }
                    </div>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.logo')}</TableCell>
                <TableCell colSpan={5} style={{textAlign: "left"}}>
                    <div style={{display:"flex"}}>
                    <input
                        style={{margin:"8px"}}
                        type="file" 
                        accept={'.jpg,.jpeg,.png,.gif'}
                        onChange={(e)=>setLogoFile(e.target.files[0])}
                    />
                    {/* {company.logoFile && <img src={`${window.RUNTIME_CONFIG.REACT_APP_API_URL}/api/download/${company.logoFile?.id}`} width="180px" height="45px" />} */}
                    {(company.info?.logoFile && logoFileId !== null) &&
                        <div style={{display:"flex", alignItems: "center"}}>
                            <FileDownloadIcon file={company.info?.logoFile} iconSize="large" viewFileName={true} />
                            <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer", paddingLeft:"5px"}} onClick={() => setLogoFileId(null)}>-</RemoveCircleOutlineIcon>
                        </div>
                    }
                    </div>
                </TableCell>
            </TableRow>
            </TableBody>
            </Table>
        </TableContainer>
        </form>

        <div style={{marginTop:"10px", display:"flex", justifyContent:"space-between"}}>
            <div>
                <Link to={'/setting/company/company-user'+searchParam}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.list')}</Button></Link>
            </div>
            {((loginInfo.role === ROLE.AD.code && loginInfo.company.id === company.id) || loginInfo.role === ROLE.SA.code) &&
            <div>
                <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>
            </div>
            }
        </div>
        </>
        }

        {/* 사용자 목록 */}
        <br/>
        {company?.id && <CompanyModifyUser company={company} loginInfo={loginInfo} />}

        {/* 구역관리 */}
        {company.type === 'MAN' &&
        (platformServer === 'NANTONG' ?
        <CompanyModifyZoneNantong company={company} loginInfo={loginInfo} zones={zones} onRefresh={requestRefresh} />
        :
        <CompanyModifyZone company={company} loginInfo={loginInfo} zones={zones} onRefresh={requestRefresh} />
        )
        }
        <div style={{marginTop:"10px",display: "flex",justifyContent: "space-between",}}>
            <div>
                <Link to={'/setting/company/company-user'+searchParam}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.list')}</Button></Link>
            </div>
        </div>
    </div>
    );
}

export default CompanyUserModifySetting;